import React, { createContext, useState, useContext } from "react";
import api from "../utils/api";

const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [token, setToken] = useState(localStorage.getItem("adminToken") || null);
  const [username, setUsername] = useState(localStorage.getItem("adminUsername") || null);

  const login = async (usernameInput, password) => {
    const { data } = await api.post("/auth/login", { username: usernameInput, password });
    localStorage.setItem("adminToken", data.token);
    localStorage.setItem("adminUsername", data.username);
    setToken(data.token);
    setUsername(data.username);
    return data;
  };

  const logout = () => {
    localStorage.removeItem("adminToken");
    localStorage.removeItem("adminUsername");
    setToken(null);
    setUsername(null);
  };

  const isAuthenticated = !!token;

  return (
    <AuthContext.Provider value={{ token, username, login, logout, isAuthenticated }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);
